import request from "root/js/request";

const getPostingCancellationDiagramInitiatorOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
}) => {
  const response = await request({
    url: "/ozon_analytics/posting_cancellation/diagram/initiator/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
    },
  });
  return response.data;
};

export { getPostingCancellationDiagramInitiatorOzon };
